
 


const assets = {
  images: {
    logo: require("./images/Eldorado.png")
  }
};

export default assets;